import * as React from "react";
import { useState, useEffect } from "react";
import { useStyles } from "../../assets/styles/Theme";
import { useTheme } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
import { GRN_API_12 } from "../../api/ApiModel";
import { externalgetApi } from "../../services/externalApis";
import InfoDisplayGrid from "../common/InfoDisplayGrid";
import StatusChip from "../common/StatusChip";
import { transformSupplierData } from "../../utils/grn/grnDataUtils";
import { AnyForNow } from "../../features/grn/types";
import { FormatDate } from "../../utils/common/DateUtils";
import { GRN_STATUS,RETURN_STATUS_CODE } from "../../utils/sys/GrnConstants";

interface ViewGrnSupplierProps {
  onOpenSidebar?: () => void;
  selectedSupplier: AnyForNow;
  grnHeader?: AnyForNow;
  grncode?: string;
  grnstatuscode?: string | number;
  statusCode?: string | number;
  origin?: string;
  hidePurchaseReceive?: boolean;
}

const ViewGrnSupplier: React.FC<ViewGrnSupplierProps> = (props) => {
  const {
    onOpenSidebar,
    selectedSupplier,
    grnHeader,
    grncode,
    grnstatuscode,
    statusCode,
    origin,
    hidePurchaseReceive = false,
  } = props;

  const theme = useTheme();
  const styles = useStyles(theme);
  const [grnStatusTypes, setGrnStatusTypes] = useState<AnyForNow[]>([]);

  const supplierData = transformSupplierData(selectedSupplier, grnHeader);

  useEffect(() => {
    fetchGrnStatusTypes();
  }, []);

  const fetchGrnStatusTypes = async () => {
    try {
      const result = await externalgetApi(GRN_API_12, "GET", {
        STS: CON_STATUS_ACTIVE,
      });
      if (Array.isArray(result)) {
        setGrnStatusTypes(result);
      }
    } catch (err) {
      console.error("Error fetching GRN status types:", err);
    }
  };

  const supplierInfoData = [
    { label: "Supplier Code", value: supplierData.supplierCode },
    { label: "Supplier Name", value: supplierData.supplierName },
    { label: "Contact/Phone", value: supplierData.contactNo },
    { label: "Email", value: supplierData.email },
    { label: "Supplier Address", value: supplierData.address },
    {label:"GRN ID", value: grncode},
     {label:"GRN Date", value: FormatDate(grnHeader?.endate)},
  ];

const normalizedStatusCode =
  RETURN_STATUS_CODE.includes(Number(statusCode) as any)
    ? GRN_STATUS.APPROVE
    : Number(statusCode);

  return (
    <>
      <Grid container spacing={1}>
        {!hidePurchaseReceive && (
          <>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Box sx={styles.box_left_align}>
                <Typography
                  sx={{ ...styles.title_text, textTransform: "uppercase" }}
                >
                  purchase receive
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
              <Box sx={styles.box_left_align}>
                <Typography
                  sx={{
                    color: theme.palette.text.secondary,
                    fontSize: (theme.typography as any).subtitle_m,
                  }}
                >
                  {/* {grncode ? `Receive#${grncode}` : ""} */}
                </Typography>
              </Box>
            </Grid>
            {origin !== "CreateGrn" && origin !== "EditGrn" ? (
              <Grid size={{ xs: 12 }} mb={4}>
                <Box sx={styles.box_left_align}>
                  <StatusChip
                     statusCode={normalizedStatusCode}
                    statusTypes={grnStatusTypes}
                    clickable={true}
                    onClick={onOpenSidebar}
                  />
                </Box>
              </Grid>
            ) : (
              <Grid size={{ xs: 12 }} mb={4}>
                <Box sx={styles.box_left_align}></Box>
              </Grid>
            )}
          </>
        )}

        <Grid size={{ xs: 12 }}>
          <InfoDisplayGrid data={supplierInfoData} />
        </Grid>
      </Grid>
    </>
  );
};

export default ViewGrnSupplier;
